import selectors from "@/lib/selectors";

const { product: selector } = selectors;

const changeImage = function (image) {
  const container = this.container;

  let currentImage = container.querySelector(`${selector.imageWrapper} img`);

  currentImage.srcset = "";
  currentImage.src = image;
};

export default function (id) {
  changeImage.call(this, id);
}
